import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class CourthouseHearing extends BaseEntityModel {
  id?: number;
  caseNumber?: number;
  department?: string;
  roomNumber?: string;
  hearingAt?: string;
  estateId?: number;
  courthouseId?: number;

  constructor(model: Partial<CourthouseHearing> = {}) {
    super(model);

    this.id = model.id;
    this.caseNumber = model.caseNumber;
    this.department = model.department;
    this.roomNumber = model.roomNumber;
    this.hearingAt = model.hearingAt;
    this.estateId = model.estateId;
    this.courthouseId = model.courthouseId;
  }
}
